/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";

// vanInsuranceLimit
function VanCashLimitViewChart({ data }: any) {
  const [state, setState] = React.useState<any>({
    series: [
      {
        name: "Actual Cash (million)",
        type: "column",
        data: [0],
      },
      {
        name: "Cash Limit (million)",
        type: "line",
        data: [0],
      },
    ],
    options: {
      chart: {
        type: "line",
      },
      stroke: {
        width: [0, 4],
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      labels: [""],
      yaxis: [
        {
          title: {
            text: "Actual Cash (million)",
          },
        },
        {
          opposite: true,
          title: {
            text: "Cash Limit (million)",
          },
        },
      ],
    },
  });

  useEffect(() => {
    if (data?.length) {
      setState((prevSate: any) => ({
        series: [
          {
            name: "Actual Cash (million)",
            type: "column",
            data: data.map((v: { cash: number }) => v.cash),
          },
          {
            name: "Cash Limit (million)",
            type: "line",
            data: data.map((v: any) => v.limit),
          },
        ],
        options: {
          ...prevSate.options,
          labels: data.map((v: any) => v.routeNo),
          // colors: [
          //   function ({ value }: any) {
          //     if (value > vanInsuranceLimit) {
          //       return "indianred";
          //     }
          //     return "#016A70";
          //   },
          // ],
        },
      }));
    }
  }, [data]);

  // const contentDisplay = (e) => `${nf.format(e.value)}`;

  // const vanCashBarColor = (point) => {
  //   if (point.value > vanInsuranceLimit) return "indianred";
  //   return "#016A70";
  // };

  // const toolTipRenderer = (context) => {
  //   const { value } = context.point || context;

  //   return <div>{`${value} Million`}</div>;
  // };

  return (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="line"
      height={390}
    />
  );
}

export default VanCashLimitViewChart;
